import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BufferVideoStage = _resolveComponent("BufferVideoStage")!
  const _component_StageScaler = _resolveComponent("StageScaler")!

  return (_openBlock(), _createBlock(_component_StageScaler, null, {
    default: _withCtx(() => [
      _createVNode(_component_BufferVideoStage, {
        "data-testid": "buffer-video-stage",
        logo: _ctx.theme_obj.logo_url,
        demoButtonText: _ctx.theme_obj.demo_request_button_text,
        showDemoLink: _ctx.theme_obj.demo_link_enabled,
        videoSource: "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8",
        fillerSlide: { url: _ctx.fillerSlideURL, show: _ctx.currentModuleId === 'fillerSlide' },
        targets: _ctx.currentTargets,
        navigatorLinks: _ctx.navigatorLinks,
        stageChatTabs: _ctx.stageChatTabs,
        sidebarPrimaryTabs: _ctx.sidebarPrimaryTabs
      }, null, 8, ["logo", "demoButtonText", "showDemoLink", "fillerSlide", "targets", "navigatorLinks", "stageChatTabs", "sidebarPrimaryTabs"])
    ]),
    _: 1
  }))
}